import { render } from "./InlineNotice.vue?vue&type=template&id=73511670&scoped=true"
import script from "./InlineNotice.vue?vue&type=script&lang=js"
export * from "./InlineNotice.vue?vue&type=script&lang=js"

import "./InlineNotice.vue?vue&type=style&index=0&id=73511670&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73511670"]])

export default __exports__